// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FigmaEyeIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M7.99993 10.8866C6.40661 10.8866 5.11328 9.59327 5.11328 7.99993C5.11328 6.40661 6.40661 5.11328 7.99993 5.11328C9.59327 5.11328 10.8866 6.40661 10.8866 7.99993C10.8866 9.59327 9.59327 10.8866 7.99993 10.8866ZM7.99993 6.11328C6.95993 6.11328 6.11328 6.95993 6.11328 7.99993C6.11328 9.03993 6.95993 9.8866 7.99993 9.8866C9.03993 9.8866 9.8866 9.03993 9.8866 7.99993C9.8866 6.95993 9.03993 6.11328 7.99993 6.11328Z" fill={fill} />
      <path d="M8.00023 14.0137C5.49355 14.0137 3.12688 12.547 1.50021 10.0003C0.793548 8.90032 0.793548 7.10699 1.50021 6.0003C3.13355 3.45364 5.50022 1.98697 8.00023 1.98697C10.5002 1.98697 12.8669 3.45364 14.4936 6.0003C15.2002 7.10032 15.2002 8.89366 14.4936 10.0003C12.8669 12.547 10.5002 14.0137 8.00023 14.0137ZM8.00023 2.98697C5.84688 2.98697 3.78688 4.2803 2.34688 6.5403C1.84688 7.32032 1.84688 8.68032 2.34688 9.46032C3.78688 11.7203 5.84688 13.0137 8.00023 13.0137C10.1536 13.0137 12.2136 11.7203 13.6536 9.46032C14.1536 8.68032 14.1536 7.32032 13.6536 6.5403C12.2136 4.2803 10.1536 2.98697 8.00023 2.98697Z" fill={fill} />
    </svg>
  );
};

export { FigmaEyeIcon };
